var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    { attrs: { title: _vm.t("ResetPasswordUpdatePage.pageTitle") } },
    [
      _c("sm-form", {
        ref: "form",
        staticClass: "reset-form",
        on: { submit: _vm.handleSubmit },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "fieldset",
                  {
                    attrs: {
                      "data-heap-redact-attributes": "value",
                      disabled: _vm.loading,
                    },
                  },
                  [
                    _c("input", {
                      staticClass: "sr-only",
                      attrs: {
                        type: "email",
                        name: "email",
                        autocomplete: "username",
                      },
                      domProps: { value: _vm.user.email },
                    }),
                    _vm._v(" "),
                    _c("sm-input", {
                      ref: "password",
                      attrs: {
                        "data-heap-redact-text": "true",
                        type: "password",
                        name: "password",
                        autocomplete: "new-password",
                        autofocus: "",
                        label: _vm.t("ResetPasswordUpdatePage.passwordLabel"),
                        placeholder: _vm.t(
                          "ResetPasswordUpdatePage.passwordPlaceholder"
                        ),
                        rules: "required|password",
                      },
                      model: {
                        value: _vm.draft.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.draft, "password", $$v)
                        },
                        expression: "draft.password",
                      },
                    }),
                    _vm._v(" "),
                    _c("sm-input", {
                      ref: "confirmPassword",
                      attrs: {
                        "data-heap-redact-text": "true",
                        type: "password",
                        name: "confirmPassword",
                        autocomplete: "new-password",
                        label: _vm.t(
                          "ResetPasswordUpdatePage.confirmPasswordLabel"
                        ),
                        placeholder: _vm.t(
                          "ResetPasswordUpdatePage.confirmPasswordPlaceholder"
                        ),
                        rules: "required|password",
                      },
                      model: {
                        value: _vm.draft.confirmPassword,
                        callback: function ($$v) {
                          _vm.$set(_vm.draft, "confirmPassword", $$v)
                        },
                        expression: "draft.confirmPassword",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "sm-button",
                      {
                        staticClass: "block-button",
                        attrs: {
                          "native-type": "submit",
                          type: "primary",
                          loading: _vm.loading,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.t("ResetPasswordUpdatePage.submitButton")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "back-to-login-link",
                            attrs: { to: { name: "LoginPage" } },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.t(
                                    "ResetPasswordUpdatePage.backToLoginLink"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _vm.errorMessage
                      ? _c("sm-help-card", {
                          attrs: { type: "warning" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n          "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            575082012
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }